import React from "react";
import { Subscribe } from "unstated";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import LanguageDropDown from "../LanguageDropDown";
import * as DOMPurify from 'dompurify';
class TopBuildHeader extends React.Component {
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <div className={DOMPurify.sanitize(this.props.parent) + " topbuild-header-footer topbuild-header"}>
            <img src={data.state.accountLogo} alt="logo" />
            <LanguageDropDown isTopBuild />
          </div>
        )}
      </Subscribe>
    );
  }
}

export default TopBuildHeader;
